import { Card, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";

function QueueInstances() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
        sorting: 1,
        sort_by: "name",
    });

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Status",
            dataIndex: "state",
            key: "state",
        },
        {
            title: "Messages",
            render: (_, record) => <p>{record.detail.messages}</p>,
        },
    ];

    const {
        status: queueListStatus,
        data: queueListRes,
        refetch: getqueueList,
    } = useQuery(
        "queue-instances",
        async () => {
            return await HTTP("/mqueue/getAmazonQueues", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getqueueList();
    }, []);

    useEffect(() => {
        getqueueList();
    }, [formData]);

    useEffect(() => {
        if (queueListStatus === "success") {
            const { data: tableData, total } = queueListRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [queueListStatus, queueListRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const newFormData = { ...formData, ...others };
        setFormData(newFormData);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader />
                <Card className="box-shadow margin-10">
                    {queueListStatus === "loading" ||
                    queueListStatus === "idle" ? (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    ) : (
                        <CustomTable
                            columns={columns}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            rowKey="id"
                            className="queue-instance-table"
                            // isScroll
                        />
                    )}
                </Card>
            </Card>
        </>
    );
}

export { QueueInstances };
